import React, { useState } from "react";

import { FiEyeOff, FiEye } from "react-icons/fi";

import { CircleBadge } from "./CircleBadge";
import {
  Container,
  Label,
  InputText,
  ContainerInput,
  ContainerIcon,
  ContainerTitleWithBadge,
} from "./styles";

export type IInputAuthType = "text" | "password" | "email";

export interface IInputAuth {
  id?: string;
  width?: number;
  height?: number;
  label: string;
  value: string;
  icon?: boolean;
  marginBottom?: string;
  marginTop?: string;
  maxLength?: number;
  type?: IInputAuthType;
  error: boolean;
  setType?: (e: IInputAuthType) => void;
  onChange: (v: string) => void;
  disabled?: boolean;
  inputRef?: any;
  autoFocus?: boolean;
  required?: boolean;
}

const InputAuth: React.FC<IInputAuth> = ({
  id,
  label,
  maxLength,
  onChange,
  value,
  disabled = false,
  marginBottom = "22px",
  marginTop,
  error = false,
  type = "text",
  setType,
  icon = false,
  width,
  height,
  inputRef,
  autoFocus,
  required,
}) => {
  const [focus, setFocus] = useState<boolean>(false);

  const activeFocus = () => {
    setFocus(true);
  };

  const inactiveFocus = () => {
    setFocus(false);
  };

  return (
    <Container marginBottom={marginBottom} marginTop={marginTop}>
      <ContainerTitleWithBadge>
        <Label>{label}</Label>
        {required && <CircleBadge radius="50px" widthHeigt="8px" />}
      </ContainerTitleWithBadge>
      <ContainerInput
        width={width}
        height={height}
        notError={!!value}
        error={error}
        focus={focus}
        
      >
        <InputText
          id={id}
          maxLength={maxLength}
          autoComplete="on"
          autoCapitalize="off"
          disabled={disabled}
          onFocus={activeFocus}
          onBlur={inactiveFocus}
          type={type}
          value={value}
          ref={inputRef}
          onChange={(e) => onChange(e.target.value)}
          autoFocus={autoFocus}
        />
        {icon && setType && (
          <ContainerIcon
            onClick={() => setType(type === "text" ? "password" : "text")}
            type="button"
          >
            {type === "text" ? (
              <FiEyeOff color="#7887A9" size={20} />
            ) : (
              <FiEye color="#7887A9" size={20} />
            )}
          </ContainerIcon>
        )}
      </ContainerInput>
    </Container>
  );
};

export default InputAuth;
